<template>
  <main>
    <b-form @submit.stop.prevent="handleSubmitCalc">
      <fieldset>
        <b-form-row class="">
          <b-col lg="4" md="4" sm="12" class="text-center pt-4 pr-4 pl-4">
            <div class="line-height-golden text-secondary">Forventelig månedlig ydelse</div>
            <p class="display-4 text-dark py-4" style="letter-spacing:-1px;">{{ monthlyAmount }} kr.</p>
          </b-col>
          <b-col lg="4" md="4" sm="12" class="text-center pt-4 pr-4 pl-4">
            <div class="line-height-golden text-secondary">Lånebeløb</div>
            <p class="display-4 text-dark py-4" style="letter-spacing:-1px;">{{ formatCurrency(loanAmount) }} kr.</p>
            <div class="sliderDiv p-2">
              <b-form-slider v-model="loanAmount" id="loanAmount" :min="5000" @change="slideStart()" @slideStop="slideEnd()" :max="350000" trigger-change-event></b-form-slider>
            </div>
            <div class="d-flex flex-row justify-content-between">
              <div class="initialism text-secondary">5.000kr</div>
              <div class="initialism text-secondary">350.000kr</div>
            </div>
          </b-col>
          <b-col lg="4" md="4" sm="12" class="text-center pt-4 pr-4 pl-4" v-if="showless">
            <div class="line-height-golden text-secondary">Lånetid</div>
            <p class="display-4 text-dark py-4" style="letter-spacing:-1px;">{{ loanTime }} år</p>
            <div class="sliderDiv p-2">
              <b-form-slider v-model="loanTime" id="loanTime" :min="1" :max="5" @slideStop="slideEnd()" trigger-change-event></b-form-slider>
            </div>
            <div class="d-flex flex-row justify-content-between">
              <div class="initialism text-secondary">12 mdr.</div>
              <div class="initialism text-secondary">60 mdr.</div>
            </div>
          </b-col>
          <b-col lg="4" md="4" sm="12" class="text-center pt-4 pr-4 pl-4" v-if="showmore">
            <div class="line-height-golden text-secondary">Lånetid</div>
            <p class="display-4 text-dark py-4" style="letter-spacing:-1px;">{{ loanTime }} år</p>
            <div class="sliderDiv p-2">
              <b-form-slider v-model="loanTime" id="loanTimemore" :min="1" :max="15" @slideStop="slideEnd()" trigger-change-event></b-form-slider>
            </div>
            <div class="d-flex flex-row justify-content-between">
              <div class="initialism text-secondary">12 mdr.</div>
              <div class="initialism text-secondary">180 mdr.</div>
            </div>
          </b-col>
        </b-form-row>
        <div class="py-4"></div>
        <b-form-row class="px-4 py-4 bg-dark">
          <b-col>
            <div class="text-center text-light pl-2 text-small">
              <span class="d-inline-block mr-1">Kreditbeløb</span>
              <span class="d-inline-block font-weight-bold">{{ loanAmount }}</span> kr.
              <span class="d-inline-block mr-1 ml-1">Variabel debitorrente</span>
              <span class="d-inline-block font-weight-bold"> {{ variableInterest }}%</span>
              <span class="d-inline-block mr-1 ml-1">AOP</span>
              <span class="d-inline-block font-weight-bold"> {{ AOP }}%</span>
              <span class="d-inline-block mr-1 ml-1">Oprettelsesgebyr</span>
              <span class="d-inline-block font-weight-bold"> {{ startFee }} kr.</span>
              <span class="d-inline-block mr-1 ml-1">Beløb der skal betales tilbage</span>
              <span class="d-inline-block font-weight-bold"> {{ totalRepayAmount }} kr.</span>
            </div>
          </b-col>
        </b-form-row>
        <b-form-row class="bg-light pt-4">
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Kundens fornavn" label-for="nameInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="nameInput" v-model="form.firstName" required class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Kundens efternavn" label-for="lastnameInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="lastnameInput" v-model="form.lastName" required class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="bg-light py-4">
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Kundens email" label-for="emailInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="emailInput" v-model="form.email" required type="email" class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Kundens telefonnummer" label-for="telInput" class="px-4 font-weight-bold text-dark">
              <b-form-input id="telInput" v-model="form.tel" required class="rounded"></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="py-4">
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Kommentar" label-for="commentsInput" class="px-4 font-weight-bold text-dark">
              <b-form-textarea id="commentsInput" placeholder="Tilføj eventuelt en kommentar" v-model="form.comments" class="rounded" :rows="3" :max-rows="6"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <b-form-group label="Tilladelse" label-for="consentInput" class="px-4">
              <b-form-checkbox id="consentInput" v-model="form.consent" value="accepted" required unchecked-value="not_accepted">
                <span class="text-secondary">Jeg giver hermed tilladelse til, at Resurs Bank kontakter kunden ifm. en uforpligtende samtale om en lånemulighed.</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-form-row class="bg-light">
        <div class="py-3"></div>
        <b-form-row>
          <b-col>
            <div class="d-flex justify-content-center">
              <b-btn variant="success" type="submit" size="lg" class="rounded mx-auto font-weight-bold p-3">
                <span class="el-icon-success mr-2"></span><span>Send oplysninger til banken</span>
              </b-btn>
            </div>
          </b-col>
        </b-form-row>
        <div class="py-4"></div>
      </fieldset>
      <loading :show="show" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-form>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'finanscalc',
  props: ['value'],
  components: {
    loading,
    Simplert
  },
  data () {
    return {
      loanAmount: 5000,
      showless: true,
      showmore: false,
      totalRepayAmount: '',
      monthlyAmount: '',
      loanTime: 5,
      dataLoan: [],
      show: false,
      label: '',
      overlay: 1,
      variableInterest: '',
      AOP: '',
      startFee: '',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        tel: '',
        comments: '',
        consent: ''
      }
    }
  },
  mounted () {
    const self = this
    setTimeout(function () {
      self.loanAmount = 5000
    }, 800)
  },
  created () {
    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true
    }
    this.slideEnd()
    this.salesPerson = localStorage.getItem('id_token_portal')
    var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
        },
        response => {
          alert('error')
        }
      )
  },
  methods: {
    change: function (value) {
      console.log(value)
    },
    handleSubmitCalc () {
      this.show = true
      var fullNameLoan = this.form.firstName + ' ' + this.form.lastName
      var data = {operation: 'callbackloan', salesPerson: this.salesPerson, fullNameLoan: fullNameLoan, telefonLoan: this.form.tel, emailLoan: this.form.email, loanAmount: this.loanAmount, terms: this.loanTime, comment: this.form.comments, dataLoan: this.dataLoan}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: 'Tak! Vi har nu sendt dine oplysninger til Resurs Bank, som vil kontakte dig snarest muligt.',
                type: 'success'
              }
              this.$refs.simplert.openSimplert(obj)
              this.form.firstName = ''
              this.form.lastName = ''
              this.form.tel = ''
              this.form.email = ''
              this.form.comment = ''
              this.form.consent = ''
            } else {
              alert(res.message)
              this.isLoadingDato = false
            }
          },
          response => {
            alert('error')
          }
        )
    },
    slideEnd () {
      this.show = true
      this.monthlyAmount = ''
      var data = {operation: 'bank', salesPerson: this.salesPerson, loanAmount: this.loanAmount, terms: this.loanTime}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.dataLoan = res
            this.monthlyAmount = this.formatCurrency(res.Repayment)
            this.startFee = this.formatCurrency(res.RegistrationFee)
            this.AOP = res.CostsPercent
            this.variableInterest = res.NominalInterestPercent
            this.totalRepayAmount = this.formatCurrency(res.TotalAmountToBeRepayed)
          },
          response => {
            alert('error')
          }
        )
    },
    formatCurrency (total) {
      var neg = false
      if (total < 0) {
        neg = true
        total = Math.abs(total)
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString()
    },
    slideStart () {
      console.log(this.loanAmount)
      if (this.loanAmount <= 60000) {
        this.showless = true
        this.showmore = false
        if (this.loanTime > 5) {
          this.loanTime = 5
        }
      } else {
        if (this.showless) this.loanTime = 15
        this.showless = false
        this.showmore = true
      }
    }
  },
  computed: {
  }
}
</script>
<style lang="less">
.slider-horizontal {
  min-width: 100%;
}
.sliderDiv > .d-inline-block {
  display: block!important;
}
.initialism {
  text-transform: none;
}
.slider.slider-horizontal .slider-track {
  background-image: none;
  background: #fff;
  height: 6px;
}
.slider-selection {
  background: #263646;
}
.slider-handle,
.slider-handle__fill {
  display: block;
  background: red;
  // -moz-box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.3);
  // -webkit-box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.3);
  // box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.3);
  // -moz-border-radius: 10px;
  // -webkit-border-radius: 10px;
  // border-radius: 10px;
}
.slider.slider-horizontal .slider-handle {
  background: #263646;
  // border: 4px solid #fff;
  position: relative;
  height:24px;
  width:24px;
  top: -4px;
}

.slider-handle--horizontal {
  height: 4px;
  width: 100%;
}

.slider-handle--disabled {
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=40);
  opacity: 0.4;
}

.slider-handle__fill {
  // background: -webkit-linear-gradient(left, #abe0ed, #46b7d5);
  // background: -o-linear-gradient(right, #abe0ed, #46b7d5);
  // background: -moz-linear-gradient(right, #abe0ed, #46b7d5);
  // background: linear-gradient(to right, #abe0ed, #46b7d5);
  position: absolute;
}

.slider-handle--horizontal .slider-handle__fill {
  top: 0;
  height: 100%;
}

.slider-handle--vertical .slider-handle__fill {
  bottom: 0;
  width: 100%;
}

// .slider-handle__handle {
//   position: relative;
//   width: 30px;
//   height: 30px;
//   border-radius: 50%;
//   background: #fff;
//   border: 4px solid red;
//   opacity: 1;
//   z-index: 1;
// }

.slider.slider-horizontal .slider-handle:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  content: '';
  pointer-events: none;
  border: 3px solid #263646;
  animation: sonarWave 2.1s linear infinite;
  opacity: 0;
}
@keyframes sonarWave {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    transform: scale(3);
    opacity: 0;
  }
}
.slider-handle__handle:before {
  // font-family: FontAwesome;
  // content: "";
  // color: #cccccc;
}

.slider-handle__handle:active {
  // background-img: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjAuNSIgeTE9IjAuMCIgeDI9IjAuNSIgeTI9IjEuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzAwMDAwMCIgc3RvcC1vcGFjaXR5PSIwLjEiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiMwMDAwMDAiIHN0b3Atb3BhY2l0eT0iMC4xMiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==");
  // background-size: 100%;
  // background-image: -webkit-gradient(linear, 50% 0%, 50% 100%, color-stop(0%, rgba(0, 0, 0, 0.1)), color-stop(100%, rgba(0, 0, 0, 0.12)));
  // background-image: -moz-linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.12));
  // background-image: -webkit-linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.12));
  // background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.12));
}

.slider-handle--horizontal .slider-handle__handle {
  top: -13px;
  touch-action: pan-y;
  -ms-touch-action: pan-y;
}

.slider-handle--vertical .slider-handle__handle {
  left: -10px;
  touch-action: pan-x;
  -ms-touch-action: pan-x;
}

input[type="range"]:focus + .slider-handle .slider-handle__handle {
  -moz-box-shadow: 0 0 8px rgba(255, 0, 255, 0.9);
  -webkit-box-shadow: 0 0 8px rgba(255, 0, 255, 0.9);
  box-shadow: 0 0 8px rgba(255, 0, 255, 0.9);
}

</style>


// WEBPACK FOOTER //
// NewFinansCalc.vue?203b51ea